import { VinylRecordIcon as PhosphorVinylRecordIcon } from "@phosphor-icons/react/dist/ssr/VinylRecord";

import { createAppIcon } from "@/components/createAppIcon";

export const ReleaseIcon = /* @__PURE__ */ createAppIcon(PhosphorVinylRecordIcon);
export const VinylIcon = ReleaseIcon;
